import './styles/tailwind.css'
import './styles/customize.css'
import Vue from 'vue'

import store from './store/'
import App from './App.vue'
import router from './router/routers'
import 'mand-mobile/lib/mand-mobile.css'
import '../src/assets/css/reset.css'
import './styles/index.less'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import '../src/utils/base'
import vConsole from 'vconsole'
import 'lib-flexible-compatibility'
import FastClick from 'fastclick'
import axios from 'axios'
import VueJsonp from 'vue-jsonp'
import vueEsign from 'vue-esign'
import VueClipBoard from 'vue-clipboard2'
import _ from 'lodash'
import tim from '@/tim'
import TIM from 'tim-js-sdk/tim-js-friendship'
import './utils/touch'
import { px2rem } from './utils/px2rem'

// Sentry
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import util from 'utils/util' // 添加手势监听指令



Vue.prototype._ = _
Vue.use(VueClipBoard);
Vue.use(vueEsign)
Vue.prototype.util = util

// const vconsole = new vConsole();
if (process.env.NODE_ENV !== 'production') {
    const vconsole = new vConsole();
}

const str = navigator.userAgent.toLowerCase();
const ver = str.match(/cpu iphone os (.*?) like mac os/);
if (!ver) {
    // 非IOS系统
    // 引入fastclick 做相关处理
    FastClick.attach(document.body);
} else {
    if (parseInt(ver[1]) < 11) {
        // 引入fastclick 做相关处理
        FastClick.attach(document.body);
    }
}
Vue.use(VueJsonp);
Vue.config.productionTip = false;
Vue.prototype.axios = axios;
// 针对父子组件向上通知
Vue.prototype.$dispatch = function (eventName, value) {
    let parent = this.$parent;
    while (parent) {
        parent.$emit(eventName, value);
        parent = parent.$parent;
    }
};

// 针对父子组件向下通知
Vue.prototype.$broadcast = function (eventName, value) {
    const broadcast = children => {
        children.forEach(child => {
            child.$emit(eventName, value);
            if (child.$children) {
                broadcast(child.$children)
            }
        });
    }
    broadcast(this.$children);
};

Vue.prototype.tim = tim;
Vue.prototype.TIM = TIM;
Vue.prototype.$px2rem = px2rem

// 姓名脱敏
Vue.filter('hideName', val => {
    const strLen = val.length
    let newStr = val.substr(0, 1)
    for (let i = 0; i < strLen - 1; i++) {
        newStr += '*'
    }
    return newStr
})
// 手机号脱敏
Vue.filter('hidePhone', val => {
    const strLen = val.length
    let newStr = val.substr(0, 2)
    for (let i = 1; i < strLen - 3; i++) {
        newStr += '*'
    }
    return newStr + val.substr(val.length - 2)
})
// 金额过滤器，千元加逗号，保留两位小数
Vue.filter('toThousands', (value, needSymbol) => {
    let realVal = '';
    if (!isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2)
        let str = String(realVal);
        realVal = (needSymbol ? '¥' : '') + str.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    } else {
        realVal = '-'
    }
    return realVal
})

if (process.env.NODE_ENV !== 'development') {
    // Sentry initialization
    Sentry.init({
        Vue,
        dsn: 'https://db3aaa73ecdf44ca9bf2e1d2af0b0211@sqm.ybsjyyn.com/20',
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ['localhost', 't-tio.ybsjyyn.com.com', 'gov.ybsjyyn.com.com', /^\//],
            }),
            new Sentry.Integrations.Breadcrumbs({
                console: false
            })
        ],
        environment: process.env.NODE_ENV,
        logErrors: true,
        release: process.env.RELEASE_VERSION,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0
    });

    Sentry.configureScope(scope => {
        scope.setUser({
            token: localStorage.getItem('X-Token') || util.cookies.get('X-Token')
        })
    })
}

export const eventBus = new Vue()
Vue.prototype.$bus = eventBus // event Bus 用于无关系组件间的通信。
export const vm = new Vue({
    router,
    store,
    created () {
        this.$store.dispatch('guide/loadKeyword') // 搜索key
        this.$store.dispatch('guide/loadHistory') // 搜索结果
    },
    render: h => h(App)
}).$mount('#app');
// 定义一个全局变量 方便调用设置title方法
App.getSystemInfo = function () {
    let systemInfo = {};
    if (window.location.href.indexOf('t-tio') !== -1 || window.location.href.indexOf('localhost') !== -1) {
        systemInfo.host = 'https://t-tio.ybsjyyn.com/'
    } else {
        systemInfo.host = 'https://gov.ybsjyyn.com/'
    }
    return systemInfo;
}
App.online = false
Vue.prototype.globalApp = App
